export default "__VITE_ASSET__$rdRu67V__"